<div class="item" [ngClass]="[visible ? 'd-block' : 'd-none']">
  <div class="item__title" [attr.data-tid]="config.dataTIdLabel">{{ config.label | translate }}</div>
  <div class="item__value" [attr.data-tid]="config.dataTIdValue">{{ text }}</div>
</div>